import React, { FC, Fragment, PropsWithChildren, useState } from 'react';
import StyledComponent, { ResponsiveStyle } from '../../core/StyledComponent';
import { isMobile } from '../../core/is-mobile';
import ShareModal from './ShareModal';
import { DesignSettings } from '@mnz/builder';
import { isDarkColor } from '../../core/image';
import { useAsync } from 'react-use';
import CustomTooltip from '../components/mui/Tooltip';

interface ShareButton extends ResponsiveStyle {
    designSettings: DesignSettings;
    isLiveMode: boolean;
}
const ShareButton: FC<PropsWithChildren<ShareButton>> = ({ children, designSettings, xs, isLiveMode, ...props }) => {
    const isShowTooltip = !designSettings.url || !isLiveMode;
    const [isOpen, setIsOpen] = useState(false);
    const [isDark, setIsDark] = useState(false);
    const handleShare = () => {
        if (isMobile() && typeof window.navigator.share !== 'undefined') {
            window.navigator.share({ url: designSettings.url });
        } else {
            setIsOpen(true);
        }
    };

    useAsync(async () => {
        const res = await isDarkColor(
            designSettings.colors.background.color,
            designSettings.colors.background.backgroundImage,
        );
        setIsDark(res);
    }, [designSettings]);

    if (isShowTooltip) {
        return (
            <CustomTooltip
                title="Once you have published, you’ll gain access to your link as well as custom share options."
                arrow
            >
                <StyledComponent xs={{ cursor: 'pointer', ...xs }} {...props}>
                    {children}
                </StyledComponent>
            </CustomTooltip>
        );
    }

    return (
        <Fragment>
            <StyledComponent xs={{ cursor: 'pointer', ...xs }} {...props} onClick={handleShare}>
                {children}
            </StyledComponent>
            <ShareModal
                open={isOpen}
                designSettings={designSettings}
                isDark={isDark}
                onClose={() => setIsOpen(false)}
            />
        </Fragment>
    );
};

export default ShareButton;
